import React from "react";
import { EditableField } from "./editable-field";
import {
  PersonalInfoApiError,
  PersonalInfoCreate,
} from "../types/personal_info.types";
import { DateField } from "./date-field";
import { GENDER_OPTIONS } from "../constants/gender-select-options";
import { BLOOD_TYPE_OPTIONS } from "../constants/blood-type-select-options";
import {
  EMAIL_PATTERN,
  PHONE_NUMBER_ARGENTINA_PATTERN,
} from "../utils/patterns";

interface PersonalInfoFormProps {
  personalInfo: PersonalInfoCreate;
  personalInfoApiError: PersonalInfoApiError;
  onChange: (e: React.ChangeEvent<HTMLElement>) => void;
}

export const PersonalInfoForm: React.FC<PersonalInfoFormProps> = ({
  personalInfo,
  personalInfoApiError,
  onChange,
}) => {
  
  return (
    <div className="space-y-4">
      <EditableField
        label="DNI"
        value={personalInfo.dni}
        onChange={onChange}
        required
        type="text"
        id="dni"
        name="dni"
        placeholder="Ingrese su DNI sin puntos"
        pattern="^\d{7,8}$"
        title="El DNI debe tener entre 7 y 9 dígitos."
        minLength={7}
        maxLength={9}
        customError={personalInfoApiError.dni ?? ""}
        apiError={personalInfoApiError.dni !== null ? "conflict" : undefined}
      />
      <EditableField
        label="Nombre"
        value={personalInfo.first_name}
        onChange={onChange}
        required
        type="text"
        name="first_name"
        id="first_name"
        placeholder="Ingrese su nombre"
        minLength={3}
        maxLength={100}
      />
      <EditableField
        label="Apellido"
        value={personalInfo.last_name}
        onChange={onChange}
        required
        type="text"
        name="last_name"
        id="last_name"
        placeholder="Ingrese su apellido"
        minLength={3}
        maxLength={100}
      />
      <EditableField
        label="Correo Electrónico"
        value={personalInfo.email || ""}
        onChange={onChange}
        type="email"
        name="email"
        id="email"
        placeholder="Ingrese su correo electrónico"
        minLength={6}
        maxLength={100}
        pattern={EMAIL_PATTERN}
        title="Ingrese un correo electrónico válido (ejemplo: usuario@dominio.com)."
        customError={personalInfoApiError.email ?? ""}
        apiError={personalInfoApiError.email !== null ? "conflict" : undefined}
      />
      <EditableField
        label="Número de Teléfono"
        value={personalInfo.primary_phone_number}
        onChange={onChange}
        required
        type="text"
        name="primary_phone_number"
        id="primary_phone_number"
        placeholder="Ingrese su número de teléfono"
        pattern={PHONE_NUMBER_ARGENTINA_PATTERN}
        title="Ingrese un número de teléfono válido (ejemplo: 3777112233)."
        minLength={10}
        maxLength={10}
      />
      <EditableField
        label="Número de Teléfono de Contacto Emergencia"
        value={personalInfo.emergency_contact_number || ""}
        onChange={onChange}
        type="text"
        name="emergency_contact_number"
        id="emergency_contact_number"
        placeholder="Ingrese su número de teléfono de su contacto de emergencia"
        pattern={PHONE_NUMBER_ARGENTINA_PATTERN}
        title="Ingrese un número de teléfono válido (ejemplo: 3777112233)."
        minLength={10}
        maxLength={10}
      />

      <DateField
        label="Fecha de Nacimiento"
        type="date"
        value={
          personalInfo.birth_date
            ? new Date(personalInfo.birth_date).toISOString().split("T")[0]
            : ""
        }
        onChange={onChange}
        name="birth_date"
        id="birth_date"
        required
      />

      <EditableField
        label="Género"
        value={personalInfo.gender!}
        onChange={onChange}
        type="select"
        options={GENDER_OPTIONS}
        name="gender"
        id="gender"
        placeholder="Seleccione su género"
        required
      />
      <EditableField
        label="Grupo Sanguíneo"
        value={personalInfo.blood_type!}
        onChange={onChange}
        type="select"
        options={BLOOD_TYPE_OPTIONS}
        name="blood_type"
        id="blood_type"
        placeholder="Seleccione su grupo sanguíneo"
      />
    </div>
  );
};
